import { address as astoAddress } from 'src/hooks/contracts/useASTOTokenContract'
import { address as usdcAddress } from 'src/hooks/contracts/useUSDCContract'

export const UNISWAP_ASTO_USDC_URL = `https://app.uniswap.org/#/swap?chain=mainnet&inputCurrency=${usdcAddress}&outputCurrency=${astoAddress}`
export const GENOME_MINING_ARTICLE_URL = `https://medium.com/@alteredstatemachine/genome-mining-faq-3ffd54a6157e`
